export default "/build/images/029-2.png?c8bbbd158dd2450a34c9b577671f157c";